import makeApiCall from "./axiosIndex";

const uomApis = {
  addUOM: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/seller/createUom`,
      data,
    }),
  fetchUomById: (id: string): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/seller/findUomById?id=${id}`,
    }),
  fetchAllUom: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: "/seller/findAllUom",
    }),
  fetchAllUomByOrg: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: "/seller/findAllUomWithOrg",
    }),
  getUOMs: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/seller/fetchUom`,
    }),
  updateUOM: (data: any, id: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/seller/updateUom`,
      data,
      params: { id },
    }),
  removeUOM: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "delete",
      url: `/seller/deleteUom`,
      params: { id },
    }),
};

export default uomApis;